export const STANDALONE = 'STANDALONE';
export const WIDGET = 'WIDGET';
export const THIRD_PARTY = 'THIRD_PARTY';